import { Switch } from "@rawa/ui/Switch"
import { fieldInstructions, fieldName } from "../fields"
import type { ControlRenderer } from "./types"

export const toggleSwitch: ControlRenderer<"toggleSwitch"> = {
  Render: ({ field, value, onChange, error }) => (
    <Switch
      id={field.id}
      checked={value ?? false}
      onChange={onChange}
      label={fieldName(field)}
      hint={fieldInstructions(field)}
      required={field.required}
      error={error}
    />
  ),
}
